export enum Colors {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Primary = 'primary',
  Secondary = 'secondary',
  TextPrimary = 'text-primary',
  Inherit = 'inherit',
}
